<template>
  <div class="pg-blank-layout">
    <component
      v-if="subLayoutData"
      :is="getSubLayoutComponent"
      :layoutProps="getSubLayoutProps"
      :subLayoutData="getChildLayoutData"
    >
      <slot></slot>
    </component>
    <slot v-else></slot>
  </div>
</template>

<script>
import BlankLayout from "@/layouts/BlankLayout.vue"
export default {
  props: {
    layoutProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    subLayoutData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    getSubLayoutComponent () {
      return this.$_.get(this.subLayoutData, "component") || BlankLayout
    },
    getSubLayoutProps () {
      return this.$_.get(this.subLayoutData, "props")
    },
    getChildLayoutData () {
      return this.$_.get(this.subLayoutData, "child")
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layouts/BlankLayout.vue